export default "__VITE_ASSET__DMqZ1du5__"